import styled from 'styled-components'

export const getStatusBadgeStyle = (status) => {
  switch (status) {
    case 'active':
      return {
        backgroundColor: '#e8f5e8',
        color: '#2e7d32',
        borderColor: '#4caf50'
      }
    case 'upcoming':
      return {
        backgroundColor: '#fff8e1',
        color: '#f57c00',
        borderColor: '#ff9800'
      }
    case 'paused':
      return {
        backgroundColor: '#fff3e0',
        color: '#ef6c00',
        borderColor: '#ff5722'
      }
    default:
      return {
        backgroundColor: '#f5f5f5',
        color: '#666',
        borderColor: '#ddd'
      }
  }
}

const getStatusDotColor = (status) => {
  switch (status) {
    case 'active':
      return { backgroundColor: '#2e7d32' }
    case 'upcoming':
      return { backgroundColor: '#f57c00' }
    case 'paused':
      return { backgroundColor: '#ef6c00' }
    default:
      return { backgroundColor: '#666' }
  }
}

export const Container = styled.div`
  min-height: 400px;
`

export const InstructionText = styled.div`
  font-size: 14px;
  margin-bottom: 16px;
  font-weight: bold;
`

export const DragDropContainer = styled.div`
  min-height: 200px;
`

export const AnnouncementCard = styled.div`
  padding: 8px;
  margin: 8px 0;
  background-color: ${({ isDragging }) => (isDragging ? '#f0f0f0' : '#ffffff')};
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: grab;
  user-select: none;
`

export const CardContent = styled.div`
  display: flex;
  align-items: center;
`

export const HamburgerIcon = styled.div`
  margin-right: 8px;
  color: #999;
  font-size: 16px;
  cursor: grab;
  user-select: none;
`

export const SequenceNumber = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #edc54a;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-size: 12px;
  font-weight: bold;
`

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  color: #666;
  font-size: 8px;
`

export const AnnouncementInfo = styled.div`
  flex: 1;
`

export const Title = styled.div`
  font-weight: bold;
  margin-bottom: 4px;
`

export const Type = styled.div`
  font-size: 12px;
  color: #666;
`

export const Centres = styled.div`
  font-size: 12px;
  color: #666;
`

export const StatusBadge = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 500;
  background-color: ${({ status }) =>
    getStatusBadgeStyle(status).backgroundColor};
  color: ${({ status }) => getStatusBadgeStyle(status).color};
`

export const StatusDot = styled.div`
  height: 4px;
  width: 4px;
  background-color: ${({ status }) =>
    getStatusDotColor(status).backgroundColor};
  border-radius: 4px;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #666;
`
